// import { InputSelect } from "#common/componentes/Inputs"
import { MasterDialog } from "#common/Dialog/Dialog"
import { UseContextsCategory } from "#competence/contexts/ContextsCategory"
import { CategoryDelete, CompetenceDelete } from "#competence/services/Api"
import { useApiSend } from "#hooks/useApiSend"
import { Stack, Typography } from "@mui/material"
import { Fragment, useMemo, useState } from "react"

export default function CategoryDeleteDialog() {
	const {
		category,
		refresh,
		openDelete: open,
		setOpenDelete: setOpen,
	} = UseContextsCategory()
	const [disabled, setDisabled] = useState(false)
	const [disabledCancelar, setDisabledCancelar] = useState(false)

	const success = () => {
		refresh()
		setOpen(false)
	}

	const end = () => {
		setDisabled(false)
		setDisabledCancelar(false)
	}
	const { fetch } = useApiSend(CategoryDelete, { success, end })

	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
				},
				disabled: disabledCancelar,
			},
			{
				label: "Confirmar",
				onClick: () => {
					setDisabled(true)
					setDisabledCancelar(true)
					fetch(category?.id)
				},
				disabled,
			},
		]
	}, [category?.id, disabled, disabledCancelar, fetch, setOpen])

	return (
		<Fragment>
			<MasterDialog
				{...{
					open,
					setOpen,
					title: `Desactivar Competencia `,
					buttons,
				}}
				maxWidth="sm"
			>
				<Stack spacing={2} sx={{ width: "100%" }}>
					<Typography variant="h5" textAlign="center">
						¿Estás seguro de que deseas desactivar la categoría{" "}
						<strong>"{category?.name}"</strong>?
					</Typography>
					<Typography variant="h6" textAlign="center">
						<strong>Esta acción no se puede deshacer.</strong>
					</Typography>
				</Stack>
			</MasterDialog>
		</Fragment>
	)
}
